import { render, staticRenderFns } from "./DespesaModal.vue?vue&type=template&id=310653b2&scoped=true"
import script from "./DespesaModal.vue?vue&type=script&lang=js"
export * from "./DespesaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310653b2",
  null
  
)

export default component.exports